import { useNavigate } from 'react-router-dom';
import { groupByRoom } from './badgeUtils';
import { flattenPurchaseOrderItems, findMatchingItem, StatusCard } from './itemStatusHelpers';

export default function ItemStatusTab({ purchaseOrders, items, projectId, roomFilter }) {
  const navigate = useNavigate();
  const flatItems = flattenPurchaseOrderItems(purchaseOrders);

  if (flatItems.length === 0) {
    return <p className="cp-empty">No items on order yet.</p>;
  }

  const groups = groupByRoom(flatItems, roomFilter);

  return (
    <div>
      {groups.map(([room, roomItems]) => (
        <div key={room} className="cp-room-group">
          <p className="cp-room-heading">{room}</p>
          {roomItems.map((item, i) => (
            <StatusCard
              key={item.itemId || i}
              item={item}
              matched={findMatchingItem(items, item)}
              projectId={projectId}
              onClick={
                item.itemId
                  ? () => navigate(`/client/projects/${projectId}/items/${item.itemId}`)
                  : undefined
              }
            />
          ))}
        </div>
      ))}
    </div>
  );
}
